import { request } from "/src/utils/index.js";

export function GetPageOperationList(params) {
  return request.get("/sys/menu/page/operation/list", { params });
}
// import { GetPageOperationList } from "/src/api/sys.js";